<template>
    <div class="custom-tab">
      <em
        class="custom-tab-cursors fas fa-chevron-left nav-left-icon"
        @click="previous()"
      />
      <div class="tab-wrapper">
        <b-tabs
          :no-nav-style="true"
          :nav-class="navContainerClass"
          v-model="tabModel"
        >
          <slot />
        </b-tabs>
      </div>
      <em
        class="custom-tab-cursors fas fa-chevron-right nav-right-icon"
        @click="next()"
      />
    </div>
  </template>
  
  <script>
  import { BTabs } from "bootstrap-vue";
  export default {
    name: "CustomTab",
    components: {
      BTabs,
    },
    props: {
      navClass: {
        type: String,
        default: () => '',
      },
      defaultActiveTab: {
        type: Number,
        default: () => null,
      }
    },
    data() {
      return {
        tabModel: null,
        theme: {},
      };
    },
    computed: {
      navContainerClass() {
        return `custom-tab-container ${this.navClass}`;
      }
    },
    watch: {
      defaultActiveTab: {
        immediate: true,
        handler(newVal) {
          if (newVal) this.tabModel = newVal;
        }
      },
      tabModel: {
        immediate: true,
        handler(newVal, oldVal) {
          if (oldVal != newVal) {
            this.$emit("input", newVal);
          }
        },
      },
    },
    methods: {
      previous() {
        this.tabModel = this.tabModel - 1;
        this.scrollTo(-120);
      },
      next() {
        this.tabModel = this.tabModel + 1;
        this.scrollTo(120);
      },
      scrollTo(scrollPixels) {
        let element = this.$el.querySelector(".custom-tab-container");
        const scrollPos = element.scrollLeft;
        element.scrollLeft = scrollPos + scrollPixels;
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .custom-tab {
    --tab-border-color: #e2e2e2;
    --nav-link-color: #727272;
    --tab-active-color: #2db782;
     --tab-font-size:14px;
    display: flex;
    align-items: flex-start;
  
    &-cursors {
      display: none;
      cursor: pointer;
      color: var(--tab-active-color);
      margin-top: 20px !important;
  
      @media only screen and (max-width: 768px) {
        display: block;
      }
  
      &.nav-left-icon {
        margin-right: 10px;
      }
      &.nav-right-icon {
        margin-left: 10px !important;
      }
    }
  
    .tabs {
      flex-grow: 1;
    }
  
    .tab-wrapper {
      flex-grow: 1;
      width: 80%;
    }
  
    ::v-deep .custom-tab-container {
      border-bottom: 1px solid var(--tab-border-color);
      margin-left: 20px;
      margin-right: 20px;
  
      @media only screen and (max-width: 768px) {
        display: inline-block;
        margin: 0 0 1em;
        white-space: nowrap;
        width: 100%;
        overflow: auto;
        overflow-y: hidden;
      }
  
      .nav-item {
        @media only screen and (max-width: 768px) {
          display: inline-block !important;
          width: auto;
        }
  
        .nav-link {
          font-size: var(--tab-font-size);
          padding-right: 70px;
          color: var(--nav-link-color);
          padding-left: 35px;
  
          &.active {
            border-bottom: 3px solid var(--tab-active-color);
            color: var(--tab-active-color);
            font-weight: bold;
  
            @media only screen and (max-width: 768px) {
              border-bottom: 2px solid var(--tab-active-color);
            }
  
            &:after {
              content: unset;
            }
          }
  
          @media only screen and (max-width: 768px) {
            font-size: 12px;
            padding-bottom: 10px;
            padding-right: 27px !important;
            width: 100%;
          }
        }
      }
    }
  }
  </style>
  